var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50194 1C3.91533 1 1 3.83859 1 7.32699C1 12.8066 6.95167 19.582 7.20533 19.867C7.27948 19.9506 7.38486 20 7.50194 20C7.61511 20 7.72049 19.9506 7.79465 19.867C8.04833 19.582 14 12.8066 14 7.32699C14 3.83859 11.0846 1 7.50194 1ZM7.50194 10.4848C5.71448 10.4848 4.25877 9.06739 4.25877 7.32699C4.25877 5.5866 5.71448 4.17299 7.50194 4.17299C9.28549 4.17299 10.7412 5.5866 10.7412 7.32699C10.7412 9.06739 9.28549 10.4848 7.50194 10.4848Z",
    stroke: "#FA6400",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.07f467a8.svg";
export { ForwardRef as ReactComponent };